export default __webpack_public_path__ + "static/media/hyperledgercertificate.5f871ebe.jpeg";